import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { trackMe } from '../../Components/ComponentAnalytics/componentAnalytics';
import Button from '../../Components/Button/Button';
import Input from '../../Components/Input/Input';
import Field from '../../Components/Form/Field.styled';
import Heading from '../../Components/Headings/Heading';
import { IconDownload, IconEmail, IconPrint } from '../../Icons/system';
import StyledKeepARecord from './KeepARecord.styled';

export const KeepARecord = ({
    id,
    className,
    title,
    headingLevel,
    fileName,
    fileSize,
    fileType,
    onClickDownload,
    onClickPrint,
    onClickEmail,
    hasError,
    errorMessage,
    emailButton,
    ...inputProps
}) => {

    useEffect(() => {
        trackMe('PatternKeepARecord [GEL]');
    }, []);

    const idError = `${id}-error`;
    const showError = hasError && !!errorMessage;
    const formatFileDetails = (`${fileType} ${fileSize}`).toUpperCase();
    const iconColor = emailButton === 'primary' ? 'white' : 'secondaryBlue';

    return (
        <StyledKeepARecord className={ className } id={ `${id}-keep-a-record` }>
            <Heading level={ headingLevel }>{title}</Heading>
            <StyledKeepARecord.IconButtonLinkWrapper>
                <IconDownload />
                <Button
                    id={ `${id}-download` }
                    variant='link'
                    onClick={ onClickDownload }
                >
                    {`Download ${fileName} (${formatFileDetails})`}
                </Button>
            </StyledKeepARecord.IconButtonLinkWrapper>
            <StyledKeepARecord.IconButtonLinkWrapper>
                <IconPrint />
                <Button
                    id={ `${id}-print` }
                    variant='link'
                    onClick={ onClickPrint }
                >
                    {`Print ${fileName}`}
                </Button>
            </StyledKeepARecord.IconButtonLinkWrapper>
            {onClickEmail &&
                <div>
                    <Field.Label htmlFor={ `${id}-email-input` }>
                        <StyledKeepARecord.IconButtonLinkWrapper>
                            <IconEmail />
                            {`Email ${fileName}`}
                        </StyledKeepARecord.IconButtonLinkWrapper>
                    </Field.Label>
                    <Input
                        id={ `${id}-email-input` }
                        name='email'
                        inputWidth='xl'
                        aria-required={ false }
                        aria-describedby={ idError }
                        hasError={ showError }
                        { ...inputProps }
                    />
                    {showError && <Field.Error id={ idError }>{errorMessage}</Field.Error>}
                    <StyledKeepARecord.IconButton
                        id={ `${id}-email` }
                        theme={ emailButton }
                        onClick={ onClickEmail }
                    >
                        <IconEmail color={ iconColor } />
                        Send
                    </StyledKeepARecord.IconButton>
                </div>
            }
        </StyledKeepARecord>
    );
};

KeepARecord.propTypes = {
    className: PropTypes.string,
    title: PropTypes.string,
    headingLevel: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.oneOf([ 2, 3, 4, 5, 6 ]),
    ]),
    emailButton: PropTypes.oneOf(['primary', 'secondary']),
    id: PropTypes.string.isRequired,
    fileName: PropTypes.string.isRequired,
    fileSize: PropTypes.string.isRequired,
    fileType: PropTypes.string,
    onClickDownload: PropTypes.func.isRequired,
    onClickPrint: PropTypes.func.isRequired,
    onClickEmail: PropTypes.func,
    hasError: PropTypes.bool,
    errorMessage: PropTypes.string,
};

KeepARecord.defaultProps = {
    className: '',
    title: 'Keep a record',
    headingLevel: 2,
    fileType: 'pdf',
    hasError: false,
    errorMessage: '',
    onClickEmail: null,
    emailButton: 'secondary'
};

export default KeepARecord;
